import { startSubmit, stopSubmit } from 'redux-form';
import { FORM_NAME } from './attachments/TicketUploadItem';
import { isAxiosError, isApolloError } from '../../utils/errorTypeCheck';
import { replaceDocumentPage } from './rest';
import { updateCachedDocument, updateTicketReviewState } from './graphql';

export const submitMyForm = (formValues, documentId, ticketId, pageIndex) => {
  return async (dispatch, getState, { client, axios }) => {
    try {
      dispatch(startSubmit(FORM_NAME));
      await replaceDocumentPage(axios, documentId, formValues, pageIndex);
      await updateCachedDocument(client, documentId);
      await updateTicketReviewState(client, ticketId);
      dispatch(stopSubmit(FORM_NAME));
    } catch (e) {
      let error = {};

      if (isAxiosError(e)) {
        error = e.message;
      } else if (isApolloError(e)) {
        error = e.graphQLErrors[0].details;
      } else {
        throw e;
      }
      dispatch(stopSubmit(FORM_NAME, { _error: error }));
      throw e;
    }
  };
};
